// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-67c9c995] {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  overflow-y: auto;\n}\n[data-v-67c9c995] tr:hover {\n  cursor: pointer;\n}\npre[data-v-67c9c995] {\n  white-space: break-spaces;\n}\n.query-wrapper[data-v-67c9c995] {\n  position: relative;\n  background: #e8eef1;\n}\n.slow-query-detail-title[data-v-67c9c995] {\n  font-size: 1.875rem;\n  color: #003545;\n}", ""]);
// Exports
module.exports = exports;
